export class SoftPhoneDetails {
  constructor({
    userName = null,
    firstName = null,
    lastName = null,
    email = null,
  } = {}) {
    (this.userName = userName),
      (this.firstName = firstName),
      (this.lastName = lastName),
      (this.email = email);
  }
}

export function createSoftPhoneDetails(data) {
  return Object.freeze(new SoftPhoneDetails(data));
}
